export const UIKIT_VERSION = "2.1.1";
export const SDK_VERSION = "1.4.0";
export const DEMO_VERSION = "2.1.1";

// These parameters need to be configured
export const appId = "f1dc778bddc646ad8f260976ca2d015c"; // for Agora Chat SDK, you can get it from Agora Console
export const APP_ID = "15cb0d28b87b425ea613fc46f7c9f974"; // for Agora RTC SDK, you can get it from Agora Console
export const appServer = "https://a41.chat.agora.io";

export const PRESENCE_CONFIG = [
  "Online",
  "Offline",
  "Away",
  "Busy",
  "Do Not Disturb",
  "Custom",
];
